
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import ItemList from './item-list.vue'
import QualificationItem from '@/components/qualification-item'
import { validatorsFun } from '@/utils/validationUtil'

@Component({
  name: 'ModuleItem',
  components: {
    QualificationItem,
    ItemList
  }
  // mixins: [ draftMixin]
})
export default class ModuleItem extends Vue {
  @Prop({ type: Object, default: () => [] }) moduleData: Record<string, any>
  @Prop({ type: Number, default: null }) currentOrder: number
  @Prop({ type: Boolean, default: false }) spread: boolean
  @State('formData', { namespace: 'qualification' }) formData: any
  @State('showRules', { namespace: 'qualification' }) showRules: any
  @Action('qualification/updateFormData') updateFormData: Function
  @Action('qualification/updateCellDetail') updateCellDetail: Function

  moduleError = false

  get filterList() {
    return this.moduleData?.children?.filter((i) => !i.hidden)
  }
  isLinkChild(child) {
    return (
      child.component !== 'input' && child.type === 'cell' && !child?.disabled
    )
  }
  isDisabledChild(child) {
    return !!child?.disabled
  }

  isLink(data) {
    if (data.children.length > 1) {
      return true
    } else {
      const child = data.children[0]
      return (
        child.component !== 'input' && child.type === 'cell' && !child?.disabled
      )
    }
  }
  isDisabled(data) {
    if (data.children.length > 1) {
      return false
    } else {
      const child = data.children[0]
      return !!child?.disabled
    }
  }
  getConfig(data) {
    return data.children.length > 1 ? data : data.children[0]
  }
  openModuleList() {
    this.$refs?.itemListRef?.openItemList()
  }
  updateValue(data) {
    this.updateFormData(data)
  }
  cellDetailChange(data) {
    this.updateCellDetail({ ...data, formIndex: this.$route.query?.formIndex})
  }
  updateModuleError(val: boolean) {
    this.moduleError = val
  }
  async validator() {
    if (this.spread) {
      const promiseArr = this.$refs?.moduleListRef?.map((i) => i?.validator())
      return new Promise((resolve) => {
        Promise.all([...promiseArr]).then((arr) => {
          const result = arr.every((i) => i === true || i.validate)
          resolve(result)
        })
      })
    }
    if (this.moduleData.children?.length > 1) {
      return new Promise((resolve) => {
        Promise.all([
          ...this.moduleData.children.map((item) => {
            const { name, validators, hidden, field } = item
            let value = this.formData?.[name]
            if (field === 'tax_value') {
              value = this.formData?.['tax_value']?.[name]
            }
            return hidden
              ? Promise.resolve({ validate: true })
              : this.$refs?.moduleListRef?.validator({childConfig: item, childFormData: this.formData})
          })
        ]).then((arr) => {
          const result = arr.every((i) =>  i === true || i.validate)
          this.moduleError = !result
          resolve(result)
        })
      })
    } else {
      return this.$refs?.moduleListRef?.validator()
    }
  }
}
